import 'flowbite';


Fancybox.bind("[data-fancybox]");

var swiper = new Swiper(".swiper-banner", {
  slidesPerView: 1,
  spaceBetween: 0,
});

var swiper_post_lancamentos = new Swiper(".swiper-post-lancamentos", {
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: '.swiper-custom-button.next',
    prevEl: '.swiper-custom-button.prev',
  },
});

var swiper_oportunidades = new Swiper(".swiper-oportunidades", {
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: '.swiper-custom-button.next',
    prevEl: '.swiper-custom-button.prev',
  },
});

var swiper_galeria_bombinhas = new Swiper(".swiper-galeria-bombinhas", {
  slidesPerView: 1,
  spaceBetween: 0,
});

var swiper_entregues = new Swiper(".swiper-entregues", {
  slidesPerView: 1,
  spaceBetween: 0,
});

var swiper_obras_gallery = new Swiper(".swiper-obras-gallery", {
  slidesPerView: 1,
  spaceBetween: 0,
});

var swiper = new Swiper(".swiper-lancamentos", {
  slidesPerView: 1,
  spaceBetween: 30,
  navigation: {
    nextEl: '.swiper-custom-button.next',
    prevEl: '.swiper-custom-button.prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
  },
});

var swiper = new Swiper(".swipper-single-lancamento", {
  slidesPerView: 1,
  spaceBetween: 30,
  navigation: {
    nextEl: '.swiper-custom-button.next',
    prevEl: '.swiper-custom-button.prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
  },
});

var swiper = new Swiper(".swipper-outras-obras", {
  slidesPerView: 1,
  spaceBetween: 30,
  navigation: {
    nextEl: '.swiper-custom-button.next',
    prevEl: '.swiper-custom-button.prev',
  },
  breakpoints: {
    728: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
});

var SPMaskBehavior = function (val) {
  return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
},
  spOptions = {
    onKeyPress: function (val, e, field, options) {
      field.mask(SPMaskBehavior.apply({}, arguments), options);
    }
  };

jQuery(function ($) {
  $('.mask-phone').mask(SPMaskBehavior, spOptions);
});